import React from "react";

import classes from "./ActionBarV2.scss";

import { InformationFilled } from "@toddle-edu/ds-icons";
import { Button } from "@toddle-edu/ds-web";
import { onEnterOrSpaceKeyDown } from "Utils";

const ActionBarV2 = props => {
  const { onActionClick, t } = props;

  const onActionCardKeydown = action => e => {
    onEnterOrSpaceKeyDown(e, () => onActionClick({ action }));
  };

  return (
    <div className={classes.container}>
      <div className={classes.leftContainer}>
        <div className={classes.headingText}>
          <span style={{ marginRight: "8px", marginTop: "4px" }}>
            <InformationFilled variant={"link"} />
          </span>
          {t("journal:no_reviewer_assigned_heading")}
        </div>
        <div className={classes.subHeaderText}>
          {t("journal:no_reviewer_assigned_subtext")}
        </div>
      </div>
      <div className={classes.rightContainer}>
        <Button
          tabIndex={0}
          variant={"link"}
          onClick={() => {
            onActionClick({ action: "DRAFT" });
          }}
          onKeyDown={onActionCardKeydown("DRAFT")}
          className={classes.button}
        >
          {t("journal:move_all_posts_to_draft")}
        </Button>
        <Button
          tabIndex={0}
          variant={"link"}
          onClick={() => {
            onActionClick({ action: "APPROVE" });
          }}
          onKeyDown={onActionCardKeydown("APPROVE")}
          className={classes.button}
        >
          {t("journal:publish_all")}
        </Button>
      </div>
    </div>
  );
};

export default ActionBarV2;
